<template>
  <aside class="migration-notice" aria-label="Account migration">
    <h2>{{ possibleMatch ? 'We may have found your existing account.' : (required ? 'Migrate your account first' : 'First time signing in with Google?') }}</h2>
    <p v-if="possibleMatch">
      An existing Microsoft account uses the same email username as your Google account.
      Use the migration portal to connect your existing account. If this account belongs
      to someone else, contact your ARC administrator before creating a new account.
    </p>
    <p v-else-if="required">
      Your Google account is not linked to your existing ARC account yet.
      Complete your ARC account migration in the migration portal and wait for approval,
      then return here to sign in.
    </p>
    <p v-else>
      Migrate your existing ARC account in the migration portal and wait for approval
      before signing in with Google. Already migrated? Continue below.
    </p>
    <a v-if="portalUrl" :href="portalUrl" target="_blank" rel="noopener noreferrer">
      Migrate your account <span class="new-tab-note">(opens in a new tab)</span>
    </a>
    <p v-else class="portal-help">Contact your ARC administrator for the migration portal link.</p>
  </aside>
</template>

<script>
export default {
  name: 'AccountMigrationNotice',
  props: {
    required: { type: Boolean, default: false },
    possibleMatch: { type: Boolean, default: false }
  },
  computed: {
    portalUrl () {
      const configured = (process.env.VUE_APP_ACCOUNT_MIGRATION_URL || '').trim()
      if (!configured) return null
      try {
        const url = new URL(configured)
        const localDevelopment = process.env.NODE_ENV === 'development' &&
          ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)
        if (url.username || url.password || (url.protocol !== 'https:' && !(localDevelopment && url.protocol === 'http:'))) return null
        return url.href
      } catch (error) {
        return null
      }
    }
  }
}
</script>

<style scoped lang="scss">
.migration-notice {
  max-width: 540px;
  margin: 0 auto 24px;
  padding: 20px 24px;
  border: 1px solid #d4e3f7;
  border-radius: 8px;
  background: #f3f7fd;
  text-align: left;

  h2 {
    margin: 0 0 10px;
    font-size: 18px;
    font-weight: 700;
    color: #212741;
  }

  p {
    margin: 0 0 12px;
    color: #39415b;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.6;
    text-align: left;
  }

  a {
    color: #0158e3;
    font-size: 14px;
    font-weight: 700;
    text-decoration: underline;
  }

  .portal-help {
    margin-bottom: 0;
  }

  .new-tab-note {
    font-weight: 400;
  }
}
</style>
